<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="pla"><span class="epub-b">MAJOR PLAYERS</span></p>
<p class="h2"><span class="epub-b">YEAR 2029, HUMAN RESISTANCE</span></p>
<p class="nl">John Connor, leader</p>
<p class="nl">Kate Brewster, leader</p>
<p class="nl">Michaela “Mike” Herrera, scientific adviser</p>
<p class="nl">Daniel Ávila, programming adviser</p>
<p class="nl">Dr. Tamara Lake, medical adviser</p>
<p class="nl">Resistance 1st Security Regiment:</p>
<p class="nsl">Colonel Sidney Walker, commander</p>
<p class="nsl">Lieutenant David “Ten” Zimmerman, squadron leader, Hell-Hounds (Company A, Squadron 3)</p>
<p class="nsl">Earl Duncan, Hell-Hounds</p>
<p class="nsl">Mark Herrera, Hell-Hounds</p>
<p class="nsl">Kyla Connor, Hell-Hounds</p>
<p class="nsl">Ripper, Hell-Hounds</p>
<p class="nsl">Ginger, Hell-Hounds</p>
<p class="h2"><span class="epub-b">PRESENT DAY</span></p>
<p class="nl">Danny Ávila, programmer, Cyber Research Systems (CRS)</p>
<p class="nl">Linda Ávila, deputy, Kern County Sheriff’s Department</p>
<p class="nl">Teresa “Mama” Ávila</p>
<p class="nl">Lieutenant General Robert Brewster, head of operations, CRS</p>
<p class="nl">Dr. Philip Sherman, lead programmer, CRS</p>
<p class="nl">Jerry Squires, programmer, CRS</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// play.vue?6439dcd6